import script from "./AssertionSet.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssertionSet.vue?vue&type=script&setup=true&lang=ts"

import "./AssertionSet.vue?vue&type=style&index=0&id=673d306a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673d306a"]])

export default __exports__